<template>
  <section class="slider slider--service">
    <h1>
      Unser Service<br />
      für Sie
    </h1>

    <VueSlickCarousel v-bind="settings">
      <div class="slider-content" v-for="(item, index) in data" v-bind:key="index">
        <h2 v-html="item.name" />

        <Button
          variant="primary"
          external
          v-bind:url="'tel:' + item.tel"
          v-bind:text="item.telText"
        />

        <Button variant="outline" external v-bind:url="'mailto:' + item.mail" text="E-Mail" />
      </div>
    </VueSlickCarousel>

    <p>
      Sie benötigen weitere Informationen?
    </p>

    <a class="textlink textlink--primary" href="https://www.danogips.de/" target="_blank"
      >Zur Danogips Website</a
    >
  </section>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import Button from '@/components/Button.vue';
import data from '@/data/serviceContacts.json';

export default {
  name: 'ServiceSlider',
  components: {
    VueSlickCarousel,
    Button,
  },
  data() {
    return {
      data,
      settings: {
        arrows: true,
        dots: false,
        edgeFriction: 0,
        focusOnSelect: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 250,
        touchThreshold: 10,
        variableWidth: true,
      },
    };
  },
};
</script>
